import React from "react";
import { usePageTitle } from "../hooks/usePageTitle";
import { Link } from "react-router-dom";

const About = () => {
  usePageTitle("About Us");

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-white mb-6">
        About Collect Arena
      </h1>

      <div className="space-y-8 text-gray-300">
        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            What is Collect Arena?
          </h2>
          <p className="mb-4">
            Collect Arena is an interactive knowledge-based quiz platform where
            users test their expertise across hundreds of curated lists. From
            Olympic sports to world capitals, from movie franchises to musical
            instruments, we challenge you to recall and type out items from
            memory.
          </p>
          <p>
            Whether you're a casual player looking to test your knowledge or a
            competitive speed-runner chasing personal bests, Collect Arena
            offers the perfect challenge for every type of quiz enthusiast.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            Our Mission
          </h2>
          <p className="mb-3">
            We believe that learning and testing knowledge should be engaging,
            challenging, and fun. Collect Arena provides a clean, modern
            platform where users can:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Challenge themselves across diverse topics</li>
            <li>Track and improve their performance over time</li>
            <li>Discover new information while testing existing knowledge</li>
            <li>Compete against their own personal bests</li>
            <li>Enjoy a seamless, distraction-free quiz experience</li>
            <li className="text-green-400">
              Play with flexible difficulty modes that accept alternative
              answers
            </li>
            <li className="text-blue-400">
              Compete on global leaderboards and track your rankings
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            Privacy & Security
          </h2>
          <p>
            Your privacy matters to us. We are fully GDPR compliant, use secure
            authentication, and never sell your data. Read our{" "}
            <Link to="/privacy" className="text-blue-400 hover:text-blue-300">
              Privacy Policy
            </Link>{" "}
            for complete details.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">Contact</h2>
          <p>
            Have questions, feedback, or suggestions? We'd love to hear from
            you! Reach out at{" "}
            <a
              href="mailto:contact@collectarena.com"
              className="text-blue-400 hover:text-blue-300"
            >
              contact@collectarena.com
            </a>
            , or join us on{" "}
            <a
              href="https://discord.gg/473F5RGH99"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300"
            >
              Discord
            </a>{" "}
            and{" "}
            <a
              href="https://reddit.com/r/CollectArena"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300"
            >
              Reddit
            </a>{" "}
          </p>
        </section>

        <section className="bg-gradient-to-r from-blue-500/10 to-purple-500/10 border border-blue-500/30 rounded-lg p-6">
          <h2 className="text-2xl font-semibold text-white mb-3">
            Ready to Play?
          </h2>
          <p className="mb-4">
            Join thousands of quiz enthusiasts testing their knowledge across
            hundreds of curated lists. Whether you're here to learn, compete, or
            just have fun, Collect Arena has something for everyone.
          </p>
          <div className="flex gap-4">
            <Link
              to="/"
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition"
            >
              Browse Lists
            </Link>
            <Link
              to="/register"
              className="bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded-lg transition"
            >
              Create Account
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
